import config from "../../../../config/config";
import { apiCall } from "../../../../_services/apiCall";

/**
 * Fetches, in one bulk call, the ids of qualitative questions that have a
 * non-empty answer for the given financial year — used to show answered /
 * unanswered status in the list without a per-question request. Returns a
 * plain number[] (empty on failure).
 *
 * The "non-empty answer" definition is the backend's `hasQualitativeAnswer`;
 * the frontend's own grid-emptiness check must be kept in sync with it, since
 * the two are separate copies of the same rule across the save/read path.
 */
export const fetchAnsweredQuestionIds = async (financialYearId) => {
    if (!financialYearId) return [];
    try {
        const { isSuccess, data } = await apiCall(
            `${config.POSTLOGIN_API_URL_COMPANY}qualitative-data/answered-status/${financialYearId}`,
            {},
            {},
            "GET",
            false,
            false
        );

        if (isSuccess && Array.isArray(data?.answeredQuestionIds)) {
            return data.answeredQuestionIds.map(Number);
        }

        return [];
    } catch (error) {
        console.error("Error fetching answered status:", error);
        return [];
    }
};
